import { MenuItem, Paper, Popper, TextField } from '@mui/material'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { metodoPrograma } from '../../../../components/api'

export const InputMedicamento = ({ medicamento, setMedicamento }) => {
  const [listMedicamentos, setListMedicamentos] = useState([])
  const medicamentosFiltrados = useMemo(() => {
    const busca = medicamento?.nmMedicamento.trim().toLowerCase()
    return listMedicamentos
      ?.filter((medicamento) => {
        const nomeMedicamento = medicamento[2]?.toLowerCase()
        return nomeMedicamento.includes(busca)
      })
      .slice(0, 15)
  }, [listMedicamentos, medicamento.nmMedicamento])

  const [anchorEl, setAnchorEl] = useState(null)

  const getMedicamentos = useCallback(async () => {
    const res = await metodoPrograma('buscaMedicamentoFavorito', {})
    if (res.status) {
      setListMedicamentos(res.lista)
    }
  }, [])

  const handleSelectOption = (value) => {
    if (!value) return
    setMedicamento({
      ...medicamento,
      nmMedicamento: value[2],
    })
  }

  const handleBlur = () => {
    setTimeout(() => {
      setAnchorEl(null)
    }, 200)
  }

  useEffect(() => {
    getMedicamentos()
  }, [getMedicamentos])

  return (
    <>
      <TextField
        variant="outlined"
        margin="dense"
        label="Medicamento"
        onFocus={(e) => setAnchorEl(e.currentTarget)}
        onBlur={handleBlur}
        value={medicamento.nmMedicamento}
        fullWidth
        onChange={(e) =>
          setMedicamento({
            ...medicamento,
            nmMedicamento: e.target.value,
          })
        }
      />
      <Popper
        style={{
          zIndex: 2000,
          maxHeight: '200px',
          overflowY: 'auto',
          minWidth: anchorEl ? anchorEl.offsetWidth : '200px',
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        disablePortal
      >
        <Paper style={{ width: '100%' }}>
          {medicamentosFiltrados?.map((option) => (
            <MenuItem
              key={option[0]}
              id={`paciente-option-${option[0]}`}
              onClick={() => handleSelectOption(option)}
            >
              {option[2]}
            </MenuItem>
          ))}
        </Paper>
      </Popper>
    </>
  )
}
